<template>
  <div class="app-main">
    <div class="introduce">
      <div class="information">
        <p>姓名：{{ personArr.userName }}</p>
        <p v-if="personArr.employeeNo">工号：{{ personArr.employeeNo }}</p>
        <p v-else>手机号：{{ personArr.mobilePhone }}</p>
        <p>机构：{{ personArr.departName }}</p>
      </div>
    </div>
    <van-form v-if="!imgresUrl" :show-error="false" :scroll-to-error="true">
      <!-- <van-field
        v-model="posterForm.channelNo"
        name="channelNo"
        label="工号"
        placeholder="工号"
        :rules="[{ required: true, message: '请填写工号' }]"
        clearable
        @blur="getChanneInfo"
        <van-field v-model="" name="channelName" label="支付方式" placeholder="" readonly />
      /> -->

      <!-- <van-field name="radio" @click="sdfclick" label="推广方式">
        <template #input>
          <van-radio-group v-model="posterForm.channelName" direction="horizontal">
            <van-radio name="0">微信</van-radio>
            <van-radio name="1">支付宝</van-radio>
          </van-radio-group>
        </template>
      </van-field> -->

      <!-- <van-field class="links" v-model="posterForm.insuredUrl" name="insuredUrl" label="专属链接" placeholder="专属链接" readonly>
        <template #button>
          <van-button
            class="main-button white-color-text create-link"
            size="small"
            type="default"
            native-type="button"
            :disabled="!posterForm.insuredUrl"
            @click="copy($event, posterForm.insuredUrl)"
          >
            复制链接
          </van-button>
        </template>
      </van-field> -->
      <div class="swiper-container">
        <h5 class="poster_title">请选择海报模版</h5>
        <van-swipe
          class="my-swipe"
          :loop="false"
          :show-indicators="false"
          :width="200"
        >
          <van-swipe-item
            v-for="item in posterArray"
            :key="item.imgId"
            @click="selectCurrentImg(item.imgId)"
          >
            <div class="img-tip" v-if="item.templateType == 'wechat'">
              <span class="img-tip-title">微信二维码</span>
              <span class="img-tip-text">微信分享优先使用该专属海报</span>
            </div>
            <div class="img-tip" v-else-if="item.templateType == 'ali'">
              <span class="img-tip-title">支付宝二维码</span>
              <span class="img-tip-text">微信里无法自动识别支付宝二维码</span>
            </div>
            <div class="img-tip" v-else>
              <span class="img-tip-title">微信支付宝二维码</span>
              <span class="img-tip-text">微信、支付宝二维码均可分享</span>
            </div>
            <div v-if="item.imgId !== imgId" class="select">
              <img src="@/assets/img/poster/no-select.png" alt="" />
            </div>
            <div v-if="item.imgId === imgId" class="select">
              <img src="@/assets/img/poster/select.png" alt="" />
            </div>
            <img lazy-load :src="item.imgFileUrl" />
          </van-swipe-item>
        </van-swipe>
      </div>
      <div style="margin: 0px 16px 35px 16px">
        <van-button
          id="Agent_Generate_Poster"
          v-if="!imgresUrl"
          class="main-button-bgc white-color-text"
          round
          block
          native-type="button"
          @click="outputPoster"
        >
          生成海报
        </van-button>
        <div class="btn-tip">
          由上海金仕达卫宁软件科技有限公司提供技术支持。
        </div>
      </div>
    </van-form>
    <img v-if="imgresUrl" class="img-res" :src="imgresUrl" />
    <div class="poster_a">
      <div @click="posterdetail">海报生成</div>
      <div @click="inquiry">业绩查询</div>
    </div>
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  // 例如：import 《组件名称》 from '《组件路径》';
  import {
    findAgentUserById,
    // GetChannelDetailByChannelNo,
    GetGalleryList
  } from '@/api/poster'
  import handleClipboard from '@/util/clipboard'
  export default {
    name: 'PosterDeal',
    components: {},
    mixins: [],
    props: {},
    data() {
      return {
        path: '',
        personArr: [],
        imgresUrl: '',
        // posterForm: {
        //   channelName: '0',
        //   insuredUrl: ''
        // },
        posterForm: {
          insuredUrl: '',
          aliInsuredUrl: ''
        },
        channelId: '',
        imgId: '',
        posterArray: []
      }
    },
    computed: {},
    watch: {},
    created() {
      this.getPosterList()
    },
    mounted() {
      this.getUserList()
      console.log(`${process.env.VUE_APP_BUILD_TARGET}`, 'path')
      this.path =
        process.env.VUE_APP_BUILD_TARGET === 'prod'
          ? 'https://hmb.baoxian72.com/hunan_mobile/'
          : 'https://test.yuanxinbaoxian.com/hunan_mobile/'
    },
    // 如果页面有keep-alive缓存功能，这个函数会触发
    activated() {},
    methods: {
      sdfclick() {
        let fromCode = this.personArr.employeeNo || this.personArr.mobilePhone
        // this.posterForm.insuredUrl = '微信'
        this.posterForm.insuredUrl = `${this.path}index.html?fromSourceCode=${fromCode}&baosicode=${process.env.VUE_APP_BAOSICODE}#/area-insu-buy-detail`
        // this.posterForm.insuredUrl = '支付宝'  https://render.alipay.com/p/yuyan/180020010001198340/insure.html?bizType=HEALTH_BUSINESS_HMB_HUNAN2021&agentNo=
        this.posterForm.aliInsuredUrl =
          'https://render.alipay.com/p/yuyan/180020010001198340/insure.html?bizType=HEALTH_BUSINESS_HMB_HUNAN2021&agentNo=' +
          fromCode
        // if (this.posterForm.channelName === '0') {
        //   // this.posterForm.insuredUrl = '微信'
        //   this.posterForm.insuredUrl = `${this.path}index.html?fromSourceCode=${fromCode}&baosicode=${process.env.VUE_APP_BAOSICODE}#/area-insu-buy-detail`
        // } else {
        //   // this.posterForm.insuredUrl = '支付宝'
        //   this.posterForm.insuredUrl = `${this.path}index.html?fromSourceCode=${fromCode}&baosicode=${process.env.VUE_APP_BAOSICODE}#/area-insu-buy-detail`
        // }
      },
      // 获取个人信息
      getUserList() {
        findAgentUserById(this.$route.query).then(res => {
          console.log(res, '个人信息')
          this.personArr = res
          // let fromCode = this.personArr.employeeNo || this.personArr.mobilePhone
          this.sdfclick()
          // this.posterForm.insuredUrl = `${this.path}index.html?fromSourceCode=${fromCode}&baosicode=${process.env.VUE_APP_BAOSICODE}#/area-insu-buy-detail`
        })
      },
      posterdetail() {
        this.$router.push({
          path: '/poster-deal',
          query: {
            id: this.$route.query.id,
            token: this.$route.query.token
          }
        })
      },
      inquiry() {
        this.$router.push({
          path: '/performance-inquiry',
          query: {
            id: this.$route.query.id,
            token: this.$route.query.token
          }
        })
      },
      // 获取海报列表
      async getPosterList() {
        try {
          const res = await GetGalleryList({ token: this.$route.query.token })
          this.posterArray = res
          console.log('海报列表', res)
        } catch (e) {
          this.$notify({
            type: 'danger',
            message: e.message
          })
        }
      },
      // 选择当前海报
      selectCurrentImg(val) {
        this.imgId = val
      },
      async outputPoster() {
        if (!this.imgId) {
          this.$toast('请先选择海报')
          return false
        }
        try {
          // let fromCode = this.personArr.employeeNo || this.personArr.mobilePhone
          this.$router.push({
            path: '/poster-result',
            query: {
              token: this.$route.query.token,
              agentUserId: this.$route.query.id,
              imgId: this.imgId,
              insuredUrl: this.posterForm.insuredUrl,
              aliInsuredUrl: this.posterForm.aliInsuredUrl
            }
          })
        } catch (e) {
          this.$notify({
            type: 'danger',
            message: e.message
          })
        }
      },
      // 复制按钮
      copy(e, val) {
        handleClipboard(val, e)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .app-main {
    // text-align: center;
    // height: 100vh;
    background: #f2f2f2;
    height: 100vh;
    overflow: auto;
  }
  .introduce {
    // background: #F2F2F2;
    padding: 10px 20px;
  }
  .information {
    background: #fff;
    padding: 10px;
    border-radius: 10px;
  }
  // @import url(); 引入公共css类
  .swiper-container {
    width: 95%;
    margin: auto;
    .img-tip {
      display: flex;
      flex-direction: column;
      color: #000000;
      text-align: left;
      font-weight: 700;
      .img-tip-title {
        font-size: xvw(30);
        margin-bottom: xvw(6);
      }
      .img-tip-text {
        font-size: xvw(16);
      }
    }
  }
  .my-swipe {
    padding: 10px;
  }
  .links /deep/.van-field__label {
    line-height: 34px;
  }
  .my-swipe .van-swipe-item {
    position: relative;
    color: #fff;
    font-size: 20px;
    // line-height: 150px;
    text-align: center;
    padding-right: 10px;
    img {
      margin-top: 10px;
      margin-bottom: 10px;
      display: block;
      width: 100%;
    }
    .select {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      position: absolute;
      top: px2rem(29, 750);
      right: px2rem(46, 750);
      img {
        display: block;
      }
    }
  }
  .btn-tip {
    color: #777777;
    font-size: xvw(24);
    text-align: center;
    line-height: xvw(47);
  }
  .create-link {
    outline: none;
    border-radius: px2rem(10);
  }
  .white-color-text {
    color: #fff;
  }
  .img-res {
    width: 100%;
    display: block;
    -webkit-touch-callout: none;
  }
  .main-button {
    background: #db0003;
  }
  .poster_title {
    margin: 0px;
    padding: 20px 0 0 10px;
    font-size: px2rem(32);
    font-weight: 400;
    color: #4c4c4c;
    text-align: left;
  }
  .poster_a {
    width: 100%;
    display: flex;
    position: fixed;
    bottom: 0;
    font-size: px2rem(32);
    font-weight: 400;
    color: #4c4c4c;
    height: px2rem(100);
    line-height: px2rem(100);
    text-align: center;
    div {
      flex: 1;
      cursor: pointer;
    }
    div:nth-child(1) {
      font-weight: bold;
      color: #db0003;
      background: #f2f2f2;
    }
    div:nth-child(2) {
      background: #fff;
    }
  }
</style>
